import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IDeal } from '../interface/deal/IDeal';
import IQueryDealsBasicInfo from '../queryStrings/IQueryDealsBasicInfo';
import IDealWorkflowBasicInfo from '../interface/deal/IDealWorkflowBasicInfo';

enum DealSearchServiceEnum {
  getBasicInfo = "/basic-info",
  getDealDetail = "/detail?",
}

export default class DealSearchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/deal/search");
  }

  public getDealsBasicInfo = async (queryString: IQueryDealsBasicInfo): Promise<IDealWorkflowBasicInfo> => await this.POST(`${DealSearchServiceEnum.getBasicInfo}`, queryString);
  public getDealDetail = async (DealId: number): Promise<IDeal> => await this.GET(DealSearchServiceEnum.getDealDetail + "id=" + DealId);
}
